export const APP_CONFIG = {
  BASE_LAYOUT_CONFIG_KEY: 'metronic-react-demo1-8100',
//   VERSION: 'v8.1.0',
//   SASS_PATH: 'src/_metronic/assets/sass/core/components',
//   SASS_VARIABLES_PATH: 'src/_metronic/assets/sass/core/components/_variables.scss',
} as const

export default APP_CONFIG 